import React, { RefObject, forwardRef } from "react";
import { Link } from "react-router-dom";
import { PageRoutes } from "../../utils";
import { Button } from "../button";
import { HeaderModal } from "../headerModal/HeaderModal";
import '../../styles/components/profileModal.scss';

interface ProfileModalProps {
  visibility?: boolean;
  onClose: () => void;
  onLogout: () => void;
  fullName: string;
  email: string;
  img: string;
}

export const ProfileModal = forwardRef<HTMLDivElement, ProfileModalProps>(({ visibility, fullName, email, img, onClose, onLogout }, ref: RefObject<HTMLDivElement>) => (
    visibility && (
      <HeaderModal
        onClose={onClose}
        alignContent='r-r'
        ref={ref}
      >
        <div className="profile-modal">
          <img className="avatar-modal" src={img} alt="avatar" />
          <div className="modal-user-information">
            <p className="name-info">{fullName}</p>
            <p className="email-info">{email}</p>
          </div>
          <Link to={PageRoutes.PROFILE_PAGE}>
            <Button 
              title="Управление аккаунтом"
              className="medium-long"
              onClick={onClose}
            />
          </Link>
          <Button 
            title="Выйти"
            className="outlined dark medium-short"
            onClick={onLogout}
          />
        </div>
      </HeaderModal>
    )
  )
);
